import React, { useState, cloneElement, Fragment } from 'react'
import { Paper, Typography, LinearProgress } from '@material-ui/core'
import { Link } from '../index'
import { makeStyles, useTheme } from '@material-ui/styles'
import { t as i18n } from 'ttag'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'transparent',
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(
      3
    )}px`,
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  paper: {
    padding: `0px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    margin: `0 0 ${theme.spacing(2)}px`,
    width: '100%',
    position: 'relative'
  },
  logo: {
    margin: theme.spacing(1),
    height: '35px'
  },
  select: {
    float: 'left'
  },
  footer: {
    width: '100%'
  },
  links: {
    float: 'right'
  },
  link: {
    margin: `0 ${theme.spacing(0.5)}px`
  },
  header: {
    margin: `${theme.spacing(2)}px 0`,
    fontWeight: 600
  },
  subHeader: {
    marginBottom: `${theme.spacing(3)}px`,
    fontWeight: 600
  },
  footerWelcome: {
    margin: `${theme.spacing(2)}px 0`,
    fontSize: 14
  },
  progress: {
    width: '100%'
  },
  blocker: {
    backgroundColor: theme.palette.common.white,
    opacity: 0.5,
    width: '100%',
    height: '100%',
    borderRadius: theme.shape.borderRadius,
    position: 'absolute',
    top: 0,
    left: 0
  },
  loginBackground: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
    opacity: 0.5,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  }
}))

const Box = props => {
  const { children, cookieLink, policyLink, enableLinks } = props

  const classes = useStyles()

  const theme = useTheme()

  const [loading, setLoader] = useState(false)

  const loadLoader = load => {
    setLoader(load)
  }

  const links = [
    {
      id: 1,
      label: i18n`Cookie Policy`,
      to: cookieLink,
      visible: false,
      name: 'Footer-link-cookie'
    },
    {
      id: 3,
      label: i18n`Privacy Policy`,
      to: policyLink,
      visible: true,
      name: 'Footer-link-privacy'
    }
  ]

  return (
    <Fragment>
      <div className={classes.root}>
        <img
          data-qid={'Header-button-logo'}
          src={`images/${theme.logo.large}`}
          alt='LSEG logo'
          className={classes.logo}
        />
        <Typography
          data-qid={'Header-welcome'}
          variant='h5'
          align='center'
          className={classes.header}
        >
          {props.subHeader}
        </Typography>
        <Typography
          data-qid={'Footer-welcome'}
          align='center'
          className={classes.footerWelcome}
        >
          {props.footer}
        </Typography>
        {loading ? <LinearProgress className={classes.progress} /> : null}
        <Paper className={classes.paper}>
          {cloneElement(children, { loadLoader: loadLoader.bind(this) })}
          {loading ? <div className={classes.blocker}> </div> : null}
        </Paper>
        <div className={classes.footer}>
          <div className={classes.select}></div>
          <div className={classes.links}>
            {enableLinks &&
              links.map(
                link =>
                  link.visible && (
                    <Link
                      key={link.id}
                      to={link.to}
                      className={classes.link}
                      newTab={true}
                      data-qid={link.name}
                    >
                      <Typography variant='caption'>{link.label}</Typography>
                    </Link>
                  )
              )}
          </div>
        </div>
      </div>
      {theme.background.login !== '' ? (
        <div
          className={classes.loginBackground}
          style={{
            backgroundImage: 'url(' + theme.background.login + ')'
          }}
        >
          &nbsp;
        </div>
      ) : null}
    </Fragment>
  )
}

Box.propTypes = {
  children: PropTypes.any.isRequired,
  headerTitle: PropTypes.any.isRequired
}

Box.defaultProps = {
  enableLinks: true
}

export default Box
